import { VehicleDetailsDocumentOutput } from './vehicle-details-document-output.model';


export class VehicleDocumentDetailsUpdateOutput implements IVehicleDocumentDetailsUpdateOutput {
    status!: number;
    message!: string;
    data!: VehicleDetailsDocumentOutput;

    constructor(data?: IVehicleDocumentDetailsUpdateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? VehicleDetailsDocumentOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleDocumentDetailsUpdateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDocumentDetailsUpdateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IVehicleDocumentDetailsUpdateOutput {
    status: number;
    message: string;
    data: VehicleDetailsDocumentOutput;
}

